/* eslint-disable quotes */
import { addToGlobalThisRet } from "@plugins";

function dragAndDropInit(trigger) {
    const dropArea = document.querySelector(".js-drop-area-upload-init");

    if (trigger.classList.contains("js-edit-photo-trigger")) {
        enablePreviewBtn();
    }
    if (dropArea) {
        // Prevent default drag behaviors
        ["dragenter", "dragover", "dragleave", "drop"].forEach((eventName) => {
            dropArea.addEventListener(eventName, preventDefaults, false);
            document.body.addEventListener(eventName, preventDefaults, false);
        });

        // Highlight drop area when item is dragged over it
        ["dragenter", "dragover"].forEach((eventName) => {
            dropArea.addEventListener(eventName, highlight, false);
        });
        ["dragleave", "drop"].forEach((eventName) => {
            dropArea.addEventListener(eventName, unhighlight, false);
        });

        // Handle dropped files
        const areaInput = dropArea.querySelector(".js-drop-area-input");
        dropArea.addEventListener(
            "drop",
            (e) => {
                // handleDrop(e);
                areaInput.dispatchEvent(
                    new CustomEvent("change", {
                        detail: { files: e.dataTransfer.files },
                        bubbles: true,
                    }),
                );
            },
            false,
        );
        areaInput.addEventListener(
            "change",
            (e) => {
                if (e.detail && e.detail.files.length) {
                    e.target.files = e.detail.files;
                }

                if (e.target.files.length) {
                    deleteEditor();
                }
                // handleFiles(e.target.files);
            },
            false,
        );
    }

    function preventDefaults(e) {
        e.preventDefault();
        e.stopPropagation();
    }

    function highlight() {
        dropArea.classList.add("highlight");
    }

    function unhighlight() {
        dropArea.classList.remove("highlight");
    }

    // function handleDrop(e) {
    //     const dt = e.dataTransfer;
    //     const files = dt.files;

    //     handleFiles(files);
    // }

    // function handleFiles(files) {
    //     files = [...files];
    //     if (dropArea.classList.contains("edit-photo__drop-area")) {
    //         files.forEach(createPreviewPhotoEditor);
    //     } else if (dropArea.classList.contains("add-video__drop-area")) {
    //         files.forEach(createPreviewVideo);
    //     } else if (dropArea.classList.contains("documents-modal__drop-area")) {
    //         files.forEach(createPreviewDocument);
    //     } else {
    //         files.forEach(createPreviewMediaFiles);
    //     }
    // }

    // function createPreviewMediaFiles(file) {
    //     const box = dropArea.querySelector(".drop-area__box");
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //         const formatsVideo = ["video/mp4", "video/avi", "video/quicktime"];
    //         const formatsImage = [
    //             "image/jpeg",
    //             "image/png",
    //             "image/jpg",
    //             "image/gif",
    //             "image/svg+xml",
    //         ];
    //         const input = '<input class="drop-area__input" type="file" name="F[FILE]"/>';
    //         const removeBtn =
    //             '<button type="button" class="drop-area__item-remover js-drop-area-item-remover"></button>';
    //         if (formatsVideo.includes(file.type)) {
    //             const item = `
    //                 <div class="drop-area__item">
    //                     <div class="drop-area__video">
    //                         <video>
    //                             <source src="${reader.result}" type="${file.type}">
    //                         </video>
    //                     </div>
    //                     ${input}
    //                     ${removeBtn}
    //                 </div>
    //             `;
    //             box.insertAdjacentHTML("beforeend", item);
    //         } else if (formatsImage.includes(file.type)) {
    //             const item = `
    //                 <div class="drop-area__item">
    //                     <img src="${reader.result}" class="drop-area__img">
    //                     ${input}
    //                     ${removeBtn}
    //                 </div>
    //             `;
    //             box.insertAdjacentHTML("beforeend", item);
    //         }
    //         deleteItem();
    //     };
    // }

    // function createPreviewDocument(file) {
    //     const box = dropArea.querySelector(".drop-area__box");
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //         const formats = [
    //             "application/pdf",
    //             "application/msword",
    //             "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    //             "application/vnd.ms-powerpoint",
    //             "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    //         ];

    //         let type = null;

    //         switch (file.type) {
    //             case "application/msword":
    //                 type = "doc";
    //                 break;
    //             case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    //                 type = "docx";
    //                 break;
    //             case "application/vnd.ms-powerpoint":
    //                 type = "ppt";
    //                 break;
    //             case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
    //             case "Papayas":
    //                 type = "pptx";
    //                 break;
    //             default:
    //                 type = "pdf";
    //                 break;
    //         }

    //         const removeBtn =
    //             '<button type="button" class="drop-area__item-remove-btn button js-drop-area-item-remover">Удалить</button>';
    //         const areaInput = dropArea.querySelector(".drop-area__inner");

    //         if (formats.includes(file.type)) {
    //             const document = `
    //                 <div class="document file-input__item drop-area__item">
    //                     <svg class="document__icon" width="40px" height="53px">
    //                         <use xlink:href="images/svg-icons/document-icons/icons.svg#${type}"></use>
    //                     </svg>
    //                     <div class="document__content">
    //                         <span class="document__content-name">${file.name}</span>
    //                         <div class="document__controls">
    //                             ${removeBtn}
    //                         </div>
    //                     </div>
    //                 </div>
    //             `;
    //             box.insertAdjacentHTML("beforeend", document);
    //             dropArea.classList.add("uploaded");
    //             areaInput.style.display = "none";
    //         }
    //         deleteItem(areaInput);
    //     };
    // }

    // function createPreviewPhotoEditor(file) {
    //     const box = dropArea.querySelector(".drop-area__box");
    //     const editPhotoWrap = document.querySelector(".js-edit-photo-wrap");
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //         const formatsImage = [
    //             "image/jpeg",
    //             "image/png",
    //             "image/jpg",
    //             "image/gif",
    //             "image/svg+xml",
    //         ];
    //         const input = '<input class="drop-area__input" type="file" name="F[FILE]"/>';
    //         if (formatsImage.includes(file.type)) {
    //             const editor = `
    //                 <div class="edit-photo__pic">
    //                     <img src="${reader.result}" class="js-edit-photo-init">
    //                     ${input}
    //                     <button type="button" class="edit-photo__movable-btn js-edit-photo-movable-init"></button>
    //                     <div class="edit-photo__controls js-edit-photo-controls-init">
    //                         <button type="button" class="edit-photo__controls-btn edit-photo__controls-btn-minus"></button>
    //                         <button type="button" class="edit-photo__controls-btn edit-photo__controls-btn-plus"></button>
    //                     </div>
    //                 </div>
    //             `;
    //             box.insertAdjacentHTML("beforeend", editor);
    //             editPhotoWrap.classList.add("uploaded");
    //             enablePreviewBtn();
    //             globalThis.ret.editPhotoInit();
    //         }
    //         deleteItem();
    //     };
    // }

    // function createPreviewVideo(file) {
    //     const box = dropArea.querySelector(".drop-area__box");
    //     const reader = new FileReader();
    //     reader.readAsDataURL(file);
    //     reader.onloadend = () => {
    //         const formatsVideo = ["video/mp4", "video/avi", "video/quicktime"];
    //         const removeBtn =
    //             '<button type="button" class="drop-area__item-remove-btn button js-drop-area-item-remover">Удалить</button>';
    //         if (formatsVideo.includes(file.type)) {
    //             const video = `
    //                 <div class="drop-area__item">
    //                     <div class="drop-area__video" preload="metadata">
    //                         <video>
    //                             <source src="${reader.result}#t=0.01" type="video/mp4">
    //                         </video>
    //                     </div>
    //                     <div class="drop-area__item-wrap">
    //                         <div class="drop-area__item-title">${file.name}</div>
    //                         ${removeBtn}
    //                     </div>
    //                 </div>
    //             `;
    //             box.insertAdjacentHTML("beforeend", video);
    //             dropArea.classList.add("uploaded");
    //         }
    //         deleteItem();
    //     };
    // }

    function enablePreviewBtn() {
        const previewBtn = document.querySelector(".js-edit-photo-preview-btn");
        previewBtn.classList.remove("disabled");
    }

    function deleteEditor() {
        const editor = dropArea.querySelector(".edit-photo__pic");
        if (editor) {
            editor.remove();
        }
    }

    // function deleteItem(target) {
    //     const removeBtns = document.querySelectorAll(".js-drop-area-item-remover");
    //     removeBtns.forEach((btn) => {
    //         btn.addEventListener("click", (e) => {
    //             e.target.closest(".drop-area__item").remove();
    //             dropArea.classList.remove("uploaded");

    //             if (target) {
    //                 target.removeAttribute("style");
    //             }
    //         });
    //     });
    // }
}

addToGlobalThisRet(dragAndDropInit, "dragAndDropInit");
